// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"928":"fe527ac3","3441":"28e5d81e","6038":"fe527ac3","8552":"28e5d81e"}[chunkId] + ".chunk.css";
};